var cpnCode = "TESTEN";  // Der Couponcode, den du kopieren möchtest

var couponContainer = document.querySelector('.couponcontainer');
couponContainer.onclick = function() {
    navigator.clipboard.writeText(cpnCode).then(() => {
        alert("Couponcode kopiert: " + cpnCode);
    }).catch(err => {
        console.error("Fehler beim Kopieren: ", err);
    });
};
